import { writable } from 'svelte/store';

export const isEditActive = writable(false);

export function setEditActive(active: boolean) {
    isEditActive.set(active);
}